/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The Lexplus version the FAQ applies to; null when none is set.
 */
export enum LexplusLexplusVersionEnum {
  V1 = '1',
  V2 = '2'
}
